module.exports = __webpack_public_path__ + "static/media/s_v10_24.f999e9cc.mp3";